(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cotton-to-tshirt-scroll"] && !Shopify.designMode) return;
  try {
    
(() => {
  'use strict';
  const tag = 'ww-cotton-video-v3';
  if (customElements.get(tag)) return;
  const clamp = n => Math.max(0, Math.min(1, n));
  const ease = n => { n = clamp(n); return n * n * (3 - 2 * n); };

  class CottonVideo extends HTMLElement {
    connectedCallback() { this.boot = requestAnimationFrame(() => this.init()); }
    init() {
      if (this.life || !this.isConnected) return;
      try { this.config = JSON.parse(this.querySelector('[data-wcv-config]').textContent); } catch { return; }
      this.life = new AbortController();
      const signal = this.life.signal;
      this.video = this.querySelector('video'); this.pin = this.querySelector('.wcv-pin');
      this.poster = this.querySelector('.wcv-poster'); this.posterSource = this.querySelector('picture source');
      this.panels = [...this.querySelectorAll('.wcv-panel')]; this.loader = this.querySelector('.wcv-loader');
      this.mobile = matchMedia('(max-width: 749px)'); this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.epoch = (this.epoch || 0) + 1; this.profile = null; this.near = false; this.target = 0; this.playhead = 0; this.presented = 0;
      this.video.muted = true; this.video.defaultMuted = true;
      this.video.addEventListener('loadedmetadata', () => this.checkReady(), { signal });
      this.video.addEventListener('loadeddata', () => this.checkReady(), { signal });
      this.video.addEventListener('progress', () => this.checkReady(), { signal });
      this.video.addEventListener('canplaythrough', () => this.checkReady(), { signal });
      this.video.addEventListener('seeked', () => this.seekSettled(), { signal });
      this.video.addEventListener('error', () => {
        if (this.dataset.state === 'static' || this.dataset.state === 'error') return;
        if (this.blobURL && !this.direct) this.startDirect(); else this.fallback('media-error');
      }, { signal });
      this.mobile.addEventListener('change', () => this.mode(), { signal });
      this.reduced.addEventListener('change', () => this.mode(), { signal });
      navigator.connection?.addEventListener('change', () => this.mode(), { signal });
      addEventListener('scroll', () => {
        if (this.near && !this.started && this.getBoundingClientRect().top < innerHeight) this.startLoad();
        this.schedule();
      }, { passive: true, signal });
      addEventListener('resize', () => {
        clearTimeout(this.resizeTimer);
        this.resizeTimer = setTimeout(() => { this.mode(); this.measure(); this.observe(); this.schedule(); }, 160);
      }, { passive: true, signal });
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) { cancelAnimationFrame(this.raf); this.raf = 0; }
        else { if (this.near && !this.started) this.startLoad(); this.schedule(); }
      }, { signal });
      this.resizeObserver = new ResizeObserver(() => { this.measure(); this.schedule(); });
      this.resizeObserver.observe(this.pin);
      this.mode(); this.observe();
    }
    mode() {
      const connection = navigator.connection;
      const active = this.config.enabled && !this.reduced.matches && !connection?.saveData && !['slow-2g', '2g'].includes(connection?.effectiveType) && innerHeight >= 480 && !!this.video.canPlayType('video/mp4');
      const profile = this.mobile.matches ? 'mobile' : 'desktop';
      // Mobile address-bar resizes must not repeatedly restart a failed download.
      if (this.dataset.state === 'error' && this.profile === profile && active) return;
      if (this.active === active && this.profile === profile) return;
      this.release(); this.active = active; this.profile = profile;
      this.media = this.config[profile]; this.response = Math.max(80, Math.min(320, Number(this.config.smoothing) || 160));
      this.classList.toggle('wcv-active', active); this.classList.remove('wcv-ready', 'wcv-fallback');
      this.dataset.state = active ? 'idle' : 'static'; delete this.dataset.reason;
      this.showPoster(active ? 'first' : 'last'); this.loader.hidden = true;
      this.style.setProperty('--wcv-loaded', .03);
      this.commit(0, false); this.measure();
      if (active && this.near) this.startLoad();
    }
    showPoster(which) {
      this.posterSource.srcset = this.config.mobile[which];
      this.poster.src = this.config.desktop[which];
      this.poster.alt = which === 'first' ? this.config.firstAlt : this.config.finalAlt;
    }
    observe() {
      this.observer?.disconnect();
      const margin = Math.round(innerHeight * Math.max(1, Math.min(3, this.config.preloadScreens || 2)));
      this.observer = new IntersectionObserver(entries => {
        this.near = entries[0].isIntersecting;
        if (this.near && this.active) {
          this.measure(); this.schedule();
          if (this.getBoundingClientRect().top <= innerHeight || document.readyState === 'complete') this.startLoad();
          else {
            // Let the first product content win the initial network race.
            clearTimeout(this.loadDelay);
            this.loadDelay = setTimeout(() => this.startLoad(), 700);
          }
        } else { cancelAnimationFrame(this.raf); this.raf = 0; this.lastTime = 0; }
      }, { rootMargin: `${margin}px 0px` });
      this.observer.observe(this);
    }
    async startLoad() {
      if (!this.active || !this.near || this.started || document.hidden) return;
      this.started = true; this.dataset.state = 'loading'; this.loader.hidden = false;
      clearTimeout(this.loadDelay); const epoch = this.epoch;
      this.fetchController = new AbortController();
      this.loadTimer = setTimeout(() => this.fallback('load-timeout'), (this.config.loadTimeout || 12) * 1000);
      try {
        // One compact file is fully buffered before scrubbing: no mid-story network waits.
        const response = await fetch(this.media.url, { signal: this.fetchController.signal, credentials: 'omit', cache: 'force-cache', priority: this.getBoundingClientRect().top < innerHeight ? 'auto' : 'low' });
        if (!response.ok) throw new Error('Video unavailable');
        const total = Number(response.headers.get('content-length')) || 0;
        if (total > 20_000_000) { this.fallback('video-too-large'); return; }
        let blob;
        if (response.body?.getReader) {
          const reader = response.body.getReader(), chunks = []; let bytes = 0;
          while (true) {
            const chunk = await reader.read();
            if (chunk.done) break;
            if (epoch !== this.epoch) { await reader.cancel(); return; }
            bytes += chunk.value.byteLength;
            if (bytes > 20_000_000) { await reader.cancel(); this.fallback('video-too-large'); return; }
            chunks.push(chunk.value);
            if (total) this.style.setProperty('--wcv-loaded', Math.min(.98, bytes / total));
          }
          blob = new Blob(chunks, { type: 'video/mp4' });
        } else blob = await response.blob();
        if (epoch !== this.epoch || !this.isConnected) return;
        if (blob.size > 20_000_000) { this.fallback('video-too-large'); return; }
        this.blobURL = URL.createObjectURL(blob); this.video.src = this.blobURL;
        this.video.preload = 'auto'; this.video.load();
      } catch (error) {
        if (epoch !== this.epoch || error.name === 'AbortError') return;
        // Custom CDN URLs can deny fetch CORS while still allowing native video playback.
        this.startDirect();
      }
    }
    startDirect() {
      if (!this.active || this.direct) return;
      this.direct = true;
      if (this.blobURL) { URL.revokeObjectURL(this.blobURL); this.blobURL = null; }
      this.video.src = this.media.url; this.video.preload = 'auto'; this.video.load();
    }
    checkReady() {
      const v = this.video;
      if (!this.active || this.ready || v.readyState < 2 || !Number.isFinite(v.duration) || v.duration <= 0) return;
      if (this.direct) {
        let complete = false;
        for (let i = 0; i < v.buffered.length; i++) if (v.buffered.start(i) <= .05 && v.buffered.end(i) >= v.duration - .08) complete = true;
        if (!complete) return;
      }
      clearTimeout(this.loadTimer); this.ready = true; this.dataset.state = 'ready'; this.loader.hidden = true;
      this.frames = Math.max(2, Math.round(v.duration * (this.config.fps || 24)));
      this.lastFrameTime = (this.frames - 1) / (this.config.fps || 24);
      this.playhead = this.readTarget(); this.requestedIndex = -1; this.lastTime = 0;
      this.commit(0, true); this.schedule();
    }
    measure() {
      if (!this.pin) return;
      this.offset = parseFloat(getComputedStyle(this).getPropertyValue('--wcv-offset')) || 0;
      this.distance = Math.max(1, this.offsetHeight - this.pin.offsetHeight);
    }
    readTarget() { return clamp((-this.getBoundingClientRect().top + this.offset) / this.distance); }
    schedule() {
      if (!this.active || !this.near || document.hidden || this.raf) return;
      this.raf = requestAnimationFrame(time => this.tick(time));
    }
    tick(time) {
      this.raf = 0;
      if (!this.active || !this.near || document.hidden) return;
      this.target = this.readTarget();
      if (!this.ready) return;
      const elapsed = Math.min(80, this.lastTime ? time - this.lastTime : 16.7); this.lastTime = time;
      const difference = this.target - this.playhead;
      this.playhead = Math.abs(difference) < .0002 ? this.target : this.playhead + difference * (1 - Math.exp(-elapsed / this.response));
      const index = Math.round(this.playhead * (this.frames - 1));
      if (!this.pending && index !== this.requestedIndex) this.seek(index);
      if (this.playhead !== this.target) this.schedule(); else this.lastTime = 0;
    }
    seek(index) {
      const v = this.video, epoch = this.epoch;
      this.pending = true; this.framePresented = false; this.requestedIndex = index;
      const seconds = Math.min(this.lastFrameTime, (index + .1) / (this.config.fps || 24));
      if (typeof v.requestVideoFrameCallback === 'function') {
        this.vfc = v.requestVideoFrameCallback((time, metadata) => {
          this.vfc = 0;
          if (epoch !== this.epoch || !this.active) return;
          this.framePresented = true; this.commit(metadata.mediaTime, true);
          if (!v.seeking) this.finishSeek();
        });
      }
      // Coalesce scroll changes while a seek is outstanding; never flood the decoder.
      try { v.currentTime = seconds; } catch { this.fallback('seek-error'); return; }
      clearTimeout(this.seekTimer);
      this.seekTimer = setTimeout(() => {
        if (epoch !== this.epoch || !this.active) return;
        if (!v.seeking && v.readyState >= 2) { this.commit(v.currentTime, true); this.finishSeek(); }
        else this.fallback('decode-timeout');
      }, 1500);
    }
    seekSettled() {
      if (!this.pending || !this.active) return;
      if (!this.video.requestVideoFrameCallback || this.framePresented) {
        if (!this.framePresented) this.commit(this.video.currentTime, true);
        this.finishSeek();
      } else {
        // Old/WebKit implementations sometimes omit callbacks on a paused seek.
        cancelAnimationFrame(this.presentRAF);
        this.presentRAF = requestAnimationFrame(() => {
          this.presentRAF = 0;
          if (this.pending && !this.video.seeking && this.video.readyState >= 2) {
            this.commit(this.video.currentTime, true); this.finishSeek();
          }
        });
      }
    }
    finishSeek() {
      this.pending = false; clearTimeout(this.seekTimer); cancelAnimationFrame(this.presentRAF); this.presentRAF = 0;
      if (this.vfc) { this.video.cancelVideoFrameCallback?.(this.vfc); this.vfc = 0; }
      this.schedule();
    }
    commit(time, showVideo) {
      const progress = this.lastFrameTime ? clamp(time / this.lastFrameTime) : 0;
      this.presented = progress;
      if (showVideo) this.classList.add('wcv-ready');
      const alpha = [1 - ease((progress - .28) / .06), ease((progress - .30) / .06) * (1 - ease((progress - .82) / .06)), ease((progress - .84) / .06)];
      this.panels.forEach((panel, i) => {
        const opacity = Math.round(alpha[i] * 1000) / 1000;
        panel.style.opacity = opacity; panel.style.transform = `translateY(${(1 - opacity) * 12}px)`;
        panel.dataset.visible = String(opacity > .15);
      });
      this.style.setProperty('--wcv-progress', progress);
    }
    fallback(reason) {
      if (!this.active) return;
      // Preserve occupied scroll space once entered, avoiding an abrupt page jump.
      const keepSpace = this.getBoundingClientRect().top < 0;
      this.active = false; this.release();
      this.dataset.state = 'error'; this.dataset.reason = reason;
      this.classList.remove('wcv-ready'); this.classList.add('wcv-fallback');
      this.classList.toggle('wcv-active', keepSpace);
      this.loader.hidden = true; this.showPoster('last');
      this.lastFrameTime = 1; this.commit(1, false);
    }
    release() {
      this.epoch++; this.fetchController?.abort(); this.fetchController = null;
      cancelAnimationFrame(this.raf); this.raf = 0;
      for (const id of ['loadDelay','loadTimer','seekTimer']) clearTimeout(this[id]);
      cancelAnimationFrame(this.presentRAF); this.presentRAF = 0;
      if (this.vfc) this.video.cancelVideoFrameCallback?.(this.vfc);
      this.vfc = 0; this.pending = false; this.ready = false; this.started = false; this.direct = false;
      this.video.pause(); this.video.removeAttribute('src'); this.video.load();
      if (this.blobURL) URL.revokeObjectURL(this.blobURL);
      this.blobURL = null; this.lastFrameTime = 0; this.lastTime = 0; this.requestedIndex = -1;
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.boot); if (!this.life) return;
      this.active = false; this.release(); clearTimeout(this.resizeTimer);
      this.life.abort(); this.observer?.disconnect(); this.resizeObserver?.disconnect(); this.life = null;
    }
  }
  customElements.define(tag, CottonVideo);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
